// src/components/das-application/dasValidators.js

// const SIN_REGEX = /^\d{3}-\d{3}-\d{3}$/;
const PEN_REGEX = /^\d{9}$/;
const PHONE_REGEX =
  /^(\(\d{3}\)\s?\d{3}-\d{4}|\d{3}\s\d{3}-\d{4}|\d{3}-\d{3}-\d{4}|\d{3}\s\d{7}|\d{10})$/;

function normalizeSIN(sin) {
  return sin?.replace(/\D/g, "");
}

function luhnCheck(sinDigits) {
  let sum = 0;
  let alternate = false;

  for (let i = sinDigits?.length - 1; i >= 0; i--) {
    let digit = parseInt(sinDigits[i], 10);
    if (alternate) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }
    sum += digit;
    alternate = !alternate;
  }

  return sum % 10 === 0;
}

const knownInvalidSINs = new Set(["000000000", "111111111", "123456789"]);

function isValidSIN(sin) {
  if (!sin) return false;
  const sinDigits = normalizeSIN(sin);
  if (sinDigits.length !== 9) return false;
  if (knownInvalidSINs.has(sinDigits)) return false;
  return luhnCheck(sinDigits);
}

export const validateStep1 = (fd) => {
  const errors = {};

  const safeTrim = (value) => (typeof value === "string" ? value.trim() : "");

  if (!safeTrim(fd.legal_name)) {
    errors.legal_name = "Legal Name is required.";
  } else {
    const nameParts = safeTrim(fd.legal_name).split(" ");
    if (nameParts.length < 2) {
      errors.legal_name =
        "Please enter your full legal name (at least two words).";
    }
  }
  if (!safeTrim(fd.citizenship)) {
    errors.citizenship = "Citizenship is required.";
  }
  if (!fd.SIN || !isValidSIN(fd.SIN)) {
    errors.SIN = "Invalid SIN. Please enter a valid 9-digit SIN.";
  }
  if (!safeTrim(fd.school_id)) {
    errors.school_id = "School selection is required.";
  }
  if (!safeTrim(fd.address)) {
    errors.address = "Mailing Address is required.";
  }
  if (!safeTrim(fd.city)) {
    errors.city = "City is required.";
  }
  if (!safeTrim(fd.province)) {
    errors.province = "Province is required.";
  }
  if (!safeTrim(fd.postalCode)) {
    errors.postalCode = "Postal Code is required.";
  }
  if (!safeTrim(fd.country)) {
    errors.country = "Country is required.";
  }
  if (!fd.cellPhone || !PHONE_REGEX.test(fd.cellPhone)) {
    errors.cellPhone = "Invalid Cell Phone format.";
  }
  if (!fd.dob) {
    errors.dob = "Date of Birth is required.";
  } else {
    const today = new Date();
    const dobDate = new Date(fd.dob);
    let age = today.getFullYear() - dobDate.getFullYear();
    const m = today.getMonth() - dobDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dobDate.getDate())) {
      age--;
    }
    if (age < 14 || age > 22) {
      errors.dob = "Age must be between 14 and 22 years old.";
    }
  }

  if (!fd.PEN || !PEN_REGEX.test(fd.PEN)) {
    errors.PEN = "Invalid PEN. Must be 9 digits.";
  }

  return errors;
};

export const validateStep2 = (fd) => {
  const errors = {};

  if (
    fd.direct_to_post_secondary === undefined ||
    fd.direct_to_post_secondary === null
  ) {
    errors.direct_to_post_secondary =
      "Please indicate if you are planning to attend Post Secondary.";
  }

  if (fd.direct_to_post_secondary === true) {
    if (!fd.programs_applying_for?.trim()) {
      errors.programs_applying_for =
        "Please specify the post-secondary program(s) you are applying for.";
    }
    if (!fd.long_term_career_plans?.trim()) {
      errors.long_term_career_plans =
        "Please describe your long-term career plans.";
    }
    if (!fd.scholarship_category?.trim()) {
      errors.scholarship_category = "Please select a scholarship category.";
    }
  }

  return errors;
};

export const validateStep3 = (fd) => {
  const errors = {};

  if (!fd.achievements?.trim()) {
    errors.achievements = "Please provide evidence of your achievements.";
  }

  return errors;
};

export const validateStep4 = (fd) => {
  const errors = {};

  if (!fd.coursesCount || fd.coursesCount < 1) {
    errors.coursesCount = "At least one course must be added.";
  }

  return errors;
};
export const validateStep5 = (fd) => {
  const errors = {};

  if (!fd.referencesCount || fd.referencesCount < 2) {
    errors.referencesCount = "At least two references are required.";
  }

  return errors;
};
export const validateStep6 = (fd) => {
  const errors = {};
  return errors;
};

export const dasStepValidators = [
  validateStep1,
  validateStep2,
  validateStep3,
  validateStep4,
  validateStep5,
  validateStep6,
  isValidSIN,
];
